import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { Tkv2ReferenceBarItem } from './Tkv2ReferenceBarItem.tsx';
import { useTkv2HandleIconClick } from './useTkv2HandleIconClick.ts';

export const Tkv2PdfReportItem = () => {
  const { referenceViewOpen, selectedDataSheet } = useAppSelector(selectReferenceBarUI);
  const handleIconClick = useTkv2HandleIconClick();

  const isSelected = selectedDataSheet === 'pdf' && referenceViewOpen;

  return (
    <Tkv2ReferenceBarItem
      id="pdf"
      label="PDF Report"
      icon="pdf"
      isSelected={isSelected}
      onClick={() => handleIconClick('pdf')}
    />
  );
};
